/** function for generate errors from BE for add new tariff */
export const addTariffApiErrors: Record<string, string> = {
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  ENERGY_PRICE_COMPONENT_NOT_FOUND: 'emobility.api-errors.energy-price-component-not-found',
  TARIFF_ELEMENT_EMPTY: 'emobility.api-errors.tariif-element-empty',
  PRICE_COMPONENT_EMPTY: 'emobility.api-errors.price-component-empty',
  WRONG_TARIFF_DATE_FORMAT: 'emobility.api-errors.wrong-date-format',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  INSTALLATION_NOT_FOUND: 'emobility.api-errors.installation-no-found',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  TARIFF_ELEMENT_DATES_OVERLAP: 'emobility.api-errors.tariff-dates-overlap',
  TARIFF_EXISTS: 'emobility.api-errors.tariff-exists',
  END_DATE_NOT_VALID: 'emobility.api-errors.end-date-not-valid',
}

/** function for generate errors from BE for delete tariff */
export const deleteTariffApiErrors: Record<string, string> = {
  TARIFF_IN_USE: 'emobility.api-errors.tariff-in-use',
  TARIFF_INSTALLATION_NOT_FOUND: 'emobility.api-errors.tariff-installation-not-found',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  TARIFF_NOT_FOUND: 'emobility.api-errors.tariff-not-found',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
}

/** function for generate errors from BE for edit tariff */
export const editTariffApiErrors: Record<string, string> = {
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  CANNOT_UPDATE_TARIFF: 'emobility.api-errors.can-not-update-tariff',
  WRONG_TARIFF_DATE_FORMAT: 'emobility.api-errors.wrong-tariff-date-format',
  TARIFF_ELEMENT_DATES_OVERLAP: 'emobility.api-errors.tariff-dates-overlap',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  TARIFF_NOT_FOUND: 'emobility.api-errors.tariff-not-found',
  END_DATE_NOT_VALID: 'emobility.api-errors.end-date-not-valid',
}
